import { SkeletonItem } from 'element-ui'

const YSkeletonItem = SkeletonItem
YSkeletonItem.$depends = [SkeletonItem]
YSkeletonItem.$name = 'y-skeleton-item'
YSkeletonItem._name = 'SkeletonItem 骨架屏选项'

export default YSkeletonItem
